export const isValidLicenseId = (value: string): boolean => /^\d{20}$/.test(value);

export const isValidUpc = (value: string): boolean => /^\d{12}$/.test(value);
